import React, { Component } from "react";
import MockUp from "../../assets/home.png";
import Button from "../base/Button";

export default class MainContent extends Component {
  state = {
    email: "",
  };

  handleInputChange = (e: any) => {
    this.setState({
      [e.target.id]: e.target.value,
    });
  };

  render() {
    return (
      <div className="pt-8 overflow-hidden sm:pt-12 lg:relative lg:py-48">
        <div className="mx-auto max-w-md px-4 sm:max-w-3xl sm:px-6 lg:px-8 lg:max-w-7xl lg:grid lg:grid-cols-2 lg:gap-24">
          <div>
            <div>
              <div className="mt-6 lg:mt-0 sm:max-w-xl">
                <h1 className="text-4xl font-extrabold text-gray-900 tracking-tight">
                  Ubi App
                </h1>
                <p className="mt-6 text-md text-gray-500 text-justify">
                  Ubi App empowers B40 group with financial literacy via
                  community farming. Unlike other community farms, Ubi links
                  corporates to push for decreasing carboon footprint by
                  supporting the infrastructure to the community, helps them to
                  sell crops and generate income.
                </p>
                <p className="mt-6 text-md text-gray-500 text-justify">
                  By providing a platform to connect sponsors to B40 groups, Ubi
                  ensures sponsor incentives are given transparently. Besides,
                  community farming helps to reduce carbon dioxide emission
                  which is helpful for corporates' ESG reports.
                </p>
              </div>
              <div className="mt-12 sm:max-w-lg sm:w-full sm:flex">
                <div className="mt-4 sm:mt-0">
                  <Button
                    onClick={() =>
                      window.open(
                        "https://drive.google.com/file/d/1GKhhh1yClpDy0O3xhhmWQWpfED944kBF/view?usp=sharing",
                        "_blank"
                      )
                    }
                    className="w-full"
                    type="normal"
                    text="Download Android App"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="sm:mx-auto sm:max-w-3xl sm:px-6">
          <div className="py-12 sm:relative sm:mt-12 sm:py-16 lg:absolute lg:inset-y-0 lg:right-0 lg:w-1/2">
            <div className="hidden sm:block">
              <div className="absolute inset-y-0 left-1/2 w-screen bg-gray-50 rounded-l-3xl lg:left-80 lg:right-0 lg:w-full"></div>
              <svg
                className="absolute top-8 right-1/2 -mr-3 lg:m-0 lg:left-0"
                width="404"
                height="392"
                fill="none"
                viewBox="0 0 404 392"
              >
                <defs>
                  <pattern
                    id="837c3e70-6c3a-44e6-8854-cc48c737b659"
                    x="0"
                    y="0"
                    width="20"
                    height="20"
                    patternUnits="userSpaceOnUse"
                  >
                    <rect
                      x="0"
                      y="0"
                      width="4"
                      height="4"
                      className="text-gray-200"
                      fill="currentColor"
                    />
                  </pattern>
                </defs>
                <rect
                  width="404"
                  height="392"
                  fill="url(#837c3e70-6c3a-44e6-8854-cc48c737b659)"
                />
              </svg>
            </div>
            <div className="relative pl-4 -mr-40 sm:mx-auto sm:max-w-3xl sm:px-0 lg:max-w-none lg:h-full lg:pl-12">
              <img
                className="w-8/12 rounded-md lg:h-full lg:w-auto lg:max-w-none"
                src={MockUp}
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}
